export const HeaderNewOrder = [
    {name: "ساعت و تاریخ", key: "date"},
    {name: "شماره سفارش", key: "number_orders"},
    {name: "تعداد دستگاه", key: "number_devices"},
];
export const HeaderNewMassage = [
    {name: "ساعت و تاریخ", key: "date"},
    {name: "موضوع", key: "topic"},
];
export const HeaderAdminList = [
    {name: "نام و نام خانوادگی", key: "name"},
    {name: "شماره تماس", key: "number"},
    {name: "تاریخ آخرین ورود", key: "lastEntry"},
    {name: "سطح دسترسی", key: "access"},
    {name: "وضعیت", key: "status"},
];
export const HeaderClientList = [
    {name: "نام و نام خانوادگی", key: "name"},
    {name: "شماره تماس", key: "number"},
    {name: "تاریخ ثبت‌نام", key: "registrationDate"},
    {name: "استان و شهر", key: "city"},
    {name: "شغل", key: "datebirth"},
    {name: "تعداد دستگاه", key: "userDeviceNumbers"},

];
export const HeaderStorHouse = [
    {name: "شماره سریال", key: "serialNumber"},
    {name: "نام مدل دستگاه", key: "deviceName"},
    {name: "نام سازنده", key: "creator"},
    {name: "تاریخ ساخت", key: "datepublish"},
    {name: "کلمه عبور", key: "password"},
    {name: "پین", key: "pin"},
]
export const HeaderTransaction = [
    {name: "نام و نام خانوادگی", key: "userFullName"},
    {name: "شماره تراکنش", key: "number"},
    {name: "وضعیت تراکنش", key: "status"},
    {name: "مبلغ (تومان)", key: "amount"},
    {name: "تاریخ پرداخت", key: "date"},
    {name: "شماره کارت", key: "cardNum"},
    {name: "توضیحات", key: "description"},
]
export const HeaderNewOrderPage = [
    {name: "شماره سفارش", key: "orderNumber"},
    {name: "شماره تراکنش", key: "transactionNumber"},
    {name: "نام و نام خانوادگی", key: "name"},
    {name: "شماره تماس", key: "phoneNumber"},
    {name: "استان و شهر", key: "city"},
    {name: "وضعیت", key: "status"},
]
export const HeaderOrderList = [
    {name: "شماره سفارش", key: "orderNumber"},
    {name: "شماره تراکنش", key: "transactionNumber"},
    {name: "نام و نام خانوادگی", key: "name"},
    {name: "شماره تماس", key: "phoneNumber"},
    {name: "استان و شهر", key: "city"},
    {name: "وضعیت", key: "status"},
]
export const HeaderOrderDetail = [

    {name: "نام محصول", key: "productName"},
    {name: "تعداد انتخاب", key: "number"},
    {name: "مبلغ محصول", key: "amount"},
    {name: "هزینه با حساب تعداد", key: "cost"},
]
export const HeaderOrderAdd = [

    {name: "نام محصول", key: "productName"},
    {name: "تعداد انتخاب", key: "number"},
    {name: "مبلغ محصول", key: "amount"},
    {name: "هزینه با حساب تعداد", key: "cost"},
]
export const HeaderDeviceList = [

    {name: "شماره سریال", key: "serialNumber"},
    {name: "نام دستگاه", key:"deviceName"},
    {name: " نام مدل", key: "modelName"},
    {name: "نام و نام خانوادگی", key: "name"},
    {name: "شماره تماس", key: "phoneNumber"},
    {name: "آخرین وضعیت", key: "status"},
]
export const HeaderServiceList = [

    {name: "شماره خدمات", key: "serviceNumber"},
    {name: "شماره سریال دستگاه", key: "serialNumber"},
    {name: "تاریخ ثبت", key: "dateOfregistration"},
    {name: "نام و نام خانوادگی", key: "name"},
    {name: "شماره تماس", key: "phoneNumber"},
    {name: "نوع خدمات", key: "serviceType"},
]
export const HeaderModels = [

    {name: "نام نمایشی", key: "modelname"},
    {name: "نام سری و شماره اپدیت ", key: "seriname"},
    {name: "محیط سنجش", key: "environment"},
    {name: "نوع استفاده", key: "useType"},
    {name: "نوع سنجش", key: "testType"},
    {name: "تعداد دستگاه مرتبط", key: "countdevice"},
]
export const HeaderSystem = [

    {name: "شماره گارانتی", key: "garantinumber"},
    {name: "وضعیت اعتبار", key: "creditstatus"},
    {name: "شماره سریال", key: "serialNumber"},
    {name: "تاریخ ساخت", key: "productiondate"},

]